export default function () {
  return {
    stroke: 1, // This matches css stroke-width and node borders
    milestone: {
      height: 15.5, // This rect height gives us a *rotated* rect that matches designs (23px from top tip to bottom tip)
      rotatedHeight: 23, // Height the user sees
      padding: 10.5 // See above comment. This gives us exactly 7px padding at the top and 6px at the bottom (to match designs), once the rect is rotated.
    },
    node: {
      withChildren: {
        behind: {
          padding: {
            right: 10,
            top: 5
          },
          inner: {
            width: 6,
            height: 6
          },
          outer: {
            width: 10,
            height: 10
          }
        },
        text: {
          padding: {
            top: 14,
            right: 6
          }
        },
        margin: {
          top: 5,
          bottom: 6, // To the bottom tip
        },
        tipHeight: 7
      },
      withoutChildren: {
        behind: {
          padding: {
            right: 15,
            top: 7
          },
          inner: {
            width: 6,
            height: 6
          },
          outer: {
            width: 10,
            height: 10
          }
        },
        text: {
          padding: {
            top: 16,
            right: 9
          }
        },
        margin: {
          top: 6,
          bottom: 7
        },
        tipHeight: 0
      }
    },
    footer: {
      padding: 15, // Extra left/right padding for the extent in the minibar/brush. In pixels. Used to pad the actual extent by inverting the domain
      brush: {
        width: 0
      },
      margin: {
        top: 0,
        bottom: 2,
        left: 10,
        right: 10
      }
    },
    left: {
      defaultWidth: 300, // Never changes
      width: 300
    },
    right: {}
  }

}
